import { Skeleton } from '@/_config/lib/react-native-skeleton';
import styles from './delivery-detail-skeleton.module.scss';

export function DeliveryDetailSkeleton() {
  return (
    <div className={styles.skeleton} aria-busy="true">
      <Skeleton height={42} borderRadius={16} />
      <Skeleton height={360} borderRadius={16} />
      <div className={styles.cards}>
        <Skeleton height={98} borderRadius={16} />
        <Skeleton height={98} borderRadius={16} />
      </div>
    </div>
  );
}
